/* global System */
// register component(s) with react habitat

export default {
  TypewritingText: () => System.import('./index'),
}
